
export const AREAS = ["Höfuðborgarsvæðið", "Akureyri", "Selfoss", "Ísafjörður", "Vestmannaeyjar"];

export const CATEGORIES = [
  { id: "flutt", icon: "🏠", label: "Flutningur", color: "#2563eb", iconUrl: "/icons/cat-flutt.svg" },
  { id: "forgun", icon: "♻️", label: "Förgun / Sorpstöð", color: "#dc2626", iconUrl: "/icons/cat-forgun.svg" },
  { id: "handavinna", icon: "🔧", label: "Handavinna / Aðstoð", color: "#059669", iconUrl: "/icons/cat-handavinna.svg" },
  { id: "gardur", icon: "🌿", label: "Garðvinna", color: "#7c3aed", iconUrl: "/icons/cat-gardur.svg" },
  { id: "samferda", icon: "🚗", label: "Samferðir", color: "#0891b2", iconUrl: "/icons/cat-samferda.svg" },
  { id: "annad", icon: "⚡", label: "Annað", color: "#d97706", iconUrl: "/icons/cat-annad.svg" },
];

export const PRICE_TIERS = [
  { id: "smatt", label: "⚡ Smáverk", range: "3.000–5.000 kr", value: "4.000 kr" },
  { id: "medal", label: "🚛 Meðalverk", range: "6.000–12.000 kr", value: "9.000 kr" },
  { id: "stort", label: "💪 Stórverk", range: "12.000+ kr", value: "15.000 kr" },
  { id: "samkomulag", label: "🤝 Samkomulag", range: "Frjálst verð", value: "Samkomulag" },
];

export const STATUS_MAP = {
  open: { label: "Opið", color: "#059669", bg: "#ecfdf5" },
  claimed: { label: "Samþykkt", color: "#2563eb", bg: "#eff6ff" },
  in_progress: { label: "Í vinnslu", color: "#d97706", bg: "#fffbeb" },
  done: { label: "Lokið", color: "#6b7280", bg: "#f3f4f6" },
  disabled: { label: "Falið", color: "#ef4444", bg: "#fef2f2" },
};

// Senda & Henda — Verktegundir (PRD §4.10)
export const JOB_TYPES = [
  { id: "standard", label: "Venjulegt", icon: "📋", desc: "Flutningur, handavinna, garðvinna o.fl.", iconUrl: "/icons/jt-standard.svg" },
  { id: "senda", label: "Senda", icon: "📬", desc: "Afhending frá A til B", iconUrl: "/icons/jt-senda.svg" },
  { id: "henda", label: "Henda", icon: "🗑️", desc: "Farga gömlum hlut á Sorpu", iconUrl: "/icons/jt-henda.svg" },
  { id: "senda_og_henda", label: "Senda & Henda", icon: "🔄", desc: "Afhenda nýtt + farga gömlu í einu", iconUrl: "/icons/jt-senda-henda.svg" },
  { id: "gefa", label: "Gefa", icon: "🎁", desc: "Gefa til góðgerðar", iconUrl: "/icons/jt-gefa.svg" },
];

export const DISPOSAL_DESTINATIONS = [
  { id: "sorpa", label: "Sorpa", icon: "🗑️", desc: "Endurvinnslumiðstöð", locations: ["Sævarhöfði", "Ánanaust", "Jafnasel"] },
  { id: "godi_hirdirrinn", label: "Góði hirðirinn", icon: "🏪", desc: "Hjálpræðisherinn" },
  { id: "raudi_krossinn", label: "Rauði krossinn", icon: "➕", desc: "Rauði kross nytjamarkaður" },
  { id: "emmaus", label: "Emmaus", icon: "🤝", desc: "Emmaus notuð verslun" },
];

export const DISPOSAL_PRICING = {
  small: { label: "Lítill hlutur", range: "3.000–5.000 kr", estimate: "4.000 kr" },
  medium: { label: "Meðalstór hlutur", range: "5.000–8.000 kr", estimate: "6.500 kr" },
  large: { label: "Stór hlutur", range: "8.000–12.000 kr", estimate: "10.000 kr" },
  donate: { label: "Gefa (ódýrara)", range: "2.000–4.000 kr", estimate: "3.000 kr" },
};

// Sorpa endurvinnslumiðstöðvar — opnunartímar og GPS
export const SORPA_LOCATIONS = [
  {
    id: "saevarhofdi",
    name: "Sævarhöfði",
    area: "Reykjavík",
    address: "Sævarhöfða 2, 110 Reykjavík",
    gps: { lat: 64.1466, lng: -21.8954 },
    hours: { weekday: "08:15–17:15", saturday: "10:00–16:00", sunday: "Lokað" },
    phone: "530-6200",
  },
  {
    id: "ananaust",
    name: "Ánanaust",
    area: "Reykjavík",
    address: "Ánanaust 10, 101 Reykjavík",
    gps: { lat: 64.1508, lng: -21.9467 },
    hours: { weekday: "08:15–17:15", saturday: "10:00–16:00", sunday: "Lokað" },
    phone: "530-6200",
  },
  {
    id: "jafnasel",
    name: "Jafnasel",
    area: "Reykjavík",
    address: "Jafnasel 1, 109 Reykjavík",
    gps: { lat: 64.1048, lng: -21.8638 },
    hours: { weekday: "10:00–17:00", saturday: "10:00–16:00", sunday: "Lokað" },
    phone: "530-6200",
  },
  {
    id: "gufunes",
    name: "Gufunes",
    area: "Reykjavík",
    address: "Gufunesbær, 112 Reykjavík",
    gps: { lat: 64.1550, lng: -21.8245 },
    hours: { weekday: "08:15–17:15", saturday: "10:00–16:00", sunday: "Lokað" },
    phone: "530-6200",
  },
  {
    id: "kopavogur",
    name: "Kópavogur endurvinnslustöð",
    area: "Höfuðborgarsvæðið",
    address: "Kársnesbraut 80, 200 Kópavogur",
    gps: { lat: 64.0962, lng: -21.8768 },
    hours: { weekday: "08:15–17:15", saturday: "10:00–16:00", sunday: "Lokað" },
    phone: "530-6200",
  },
  {
    id: "hafnarfjordur",
    name: "Hafnarfjörður endurvinnslustöð",
    area: "Höfuðborgarsvæðið",
    address: "Hraunbrún 3, 220 Hafnarfjörður",
    gps: { lat: 64.0611, lng: -21.9531 },
    hours: { weekday: "08:15–17:15", saturday: "10:00–16:00", sunday: "Lokað" },
    phone: "530-6200",
  },
];

// Aksturskostnaður — Ísland feb 2026
export const FUEL_PRICE_PER_LITER = 200; // kr/L (meðalverð bensíns)
export const KM_TAX = 6.95; // kr/km (kílómetragjald 2026)

// Fermetrar forstillingar eftir flokki
export const SQM_PRESETS = {
  handavinna: [40, 60, 80, 100, 120], // íbúðarstærðir
  gardur: [100, 200, 500, 1000, 2000], // garðstærðir
};

// Ökutækjategundir — fyrir bílstjóra
export const VEHICLE_TYPES = [
  { id: "ekkert", label: "Ekkert ökutæki", icon: "🚶", capacity: "Get hjálpað við að bera", maxKg: 30 },
  { id: "folksbill", label: "Fólksbíll", icon: "🚗", capacity: "Lítill farmur", maxKg: 200 },
  { id: "sendibill_litill", label: "Sendibíll (lítill)", icon: "🚐", capacity: "Meðal farmur", maxKg: 500 },
  { id: "sendibill_stor", label: "Sendibíll (stór)", icon: "🚌", capacity: "Stór farmur", maxKg: 1200 },
  { id: "pallbill", label: "Pallbíll", icon: "🛻", capacity: "Opinn pallur", maxKg: 800 },
  { id: "vorubill", label: "Vörubíll", icon: "🚚", capacity: "Mjög stór farmur", maxKg: 3000 },
  { id: "kerrubill", label: "Með kerru", icon: "🚛", capacity: "Kerru-farmur", maxKg: 2000 },
  { id: "breytilegt", label: "Breytilegt", icon: "🔄", capacity: "Fer eftir verki", maxKg: 0 },
];
